module.exports = __webpack_public_path__ + "media/images/iconSocialShare__accent-b1f3304c9be084c09c605ef4ce79f04f.png";